var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'GroupbuyingsList'
      }
    }
  }, [_vm._v("開團管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("設定門市庫存品照片")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("設定商品照片")])])]), _c('div', {
    staticClass: "mb-2 text-danger"
  }, [_vm._v("商品照片上傳最少需2張，上限為10張")]), _c('div', {
    staticClass: "mb-2"
  }, [_vm._v("亦可先【編輯團購設定】後再上傳照片")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('b-form-group', [_c('b-form-select', {
    staticClass: "form-control form-control-sm col-12 col-xl-6",
    attrs: {
      "disabled": !_vm.canClick
    },
    model: {
      value: _vm.currentProductId,
      callback: function callback($$v) {
        _vm.currentProductId = $$v;
      },
      expression: "currentProductId"
    }
  }, [_vm.productOptions && _vm.productOptions.length > 1 ? _c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請選擇商品名稱 ")]) : _vm._e(), _vm._l(_vm.productOptions, function (productOption) {
    return _c('b-form-select-option', {
      key: productOption.id,
      attrs: {
        "value": productOption.id
      }
    }, [_vm._v(" " + _vm._s(productOption.title) + " ")]);
  })], 2)], 1)], 1), _vm.croppingImage || _vm.selectedProductImage ? _c('div', {
    staticClass: "s-edit-section"
  }, [_vm.croppingImage ? _c('div', {
    staticClass: "mb-2 form-inline"
  }, [_c('b-form-select', {
    staticClass: "s-mask-select mr-3",
    attrs: {
      "options": _vm.maskOptions,
      "size": "sm",
      "disabled": !_vm.canClick
    },
    on: {
      "change": function change($event) {
        return _vm.handleMaskSelect();
      }
    },
    model: {
      value: _vm.selectedMask,
      callback: function callback($$v) {
        _vm.selectedMask = $$v;
      },
      expression: "selectedMask"
    }
  }), _c('button', {
    staticClass: "btn btn-danger btn-sm s-cancel-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.resetCropping
    }
  }, [_vm._v(" 取消 ")]), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.cropImage
    }
  }, [_vm._v(" 確定 ")])], 1) : _vm._e(), _vm.selectedProductImage ? _c('div', {
    staticClass: "mb-2 form-inline s-btn-menu"
  }, [_vm.productImages.length < 10 ? _c('button', {
    staticClass: "btn btn-success btn-sm s-cancel-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.openFileSelector
    }
  }, [_vm._v(" 新增相片 ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.reCrop
    }
  }, [_vm._v(" 重新裁切 ")])]) : _vm._e(), _vm.selectedProductImage ? _c('div', [_c('div', {
    staticClass: "s-cropper-inner"
  }, [_vm.selectedProductImageIndex === 0 && _vm.selectedProductImage.mask_image_url ? _c('img', {
    staticStyle: {
      "position": "absolute",
      "max-width": "calc(100% - 2rem)"
    },
    attrs: {
      "src": _vm.selectedProductImage.mask_image_url
    }
  }) : _vm._e(), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.selectedProductImage.pic_url
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "s-edit-section-cropper"
  }, [_c('VueCropper', {
    ref: "cropper",
    staticClass: "sr-only",
    attrs: {
      "src": _vm.croppingImage,
      "aspect-ratio": _vm.aspectRatio,
      "initialAspectRatio": _vm.aspectRatio
    }
  }), _c('img', {
    attrs: {
      "id": _vm.randomId,
      "src": _vm.croppingImage
    }
  })], 1)]) : _vm._e(), _c('input', {
    ref: "input",
    staticClass: "s-file-input",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*",
      "multiple": true
    },
    on: {
      "change": _vm.loadImage
    }
  }), !_vm.selectedProductImage && !_vm.croppingImage && _vm.productImages.length < 10 ? _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "s-cropper-inner"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('button', {
    staticClass: "btn s-trigger-btn",
    attrs: {
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.openFileSelector
    }
  }, [_vm.canClick ? [_c('div', {
    staticClass: "add-image-icon"
  }, [_vm._v("＋")]), _c('div', [_vm._v("新增")])] : _vm._e(), !_vm.canClick ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.uploadingText())
    }
  }) : _vm._e()], 2)])])]) : _vm._e(), _c('VueDraggable', {
    staticClass: "list-unstyled s-image-list mb-5",
    attrs: {
      "handle": ".s-draggable",
      "tag": "ul",
      "move": _vm.checkMove
    },
    on: {
      "end": _vm.dragEnd
    },
    model: {
      value: _vm.productImages,
      callback: function callback($$v) {
        _vm.productImages = $$v;
      },
      expression: "productImages"
    }
  }, _vm._l(_vm.productImages, function (image, i) {
    return _c('li', {
      key: i,
      staticClass: "s-image-list-item"
    }, [_c('div', {
      staticClass: "s-draggable"
    }, [i === 0 && _vm.canClick && image.mask_image_url ? _c('div', {
      staticClass: "product-mask",
      style: {
        'background-image': 'url(' + image.mask_image_url + ')'
      }
    }) : _vm._e(), !_vm.canClick ? _c('div', {
      staticClass: "product-mask",
      style: {
        'background-image': 'url(' + _vm.loadingImage + ')'
      }
    }) : _vm._e(), _c('img', {
      staticClass: "s-cropped-image",
      attrs: {
        "src": image.pic_url
      }
    }), _c('button', {
      staticClass: "btn btn-secondary s-delete-btn",
      attrs: {
        "type": "button"
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "22px"
      },
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke-width": "1",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "d": "M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
      }
    })])])]), _c('div', {
      staticClass: "s-list-item-btn-menu"
    }, [_c('b-button', {
      staticClass: "mr-1",
      attrs: {
        "disabled": !_vm.canClick,
        "variant": "outline-dark"
      },
      on: {
        "click": function click($event) {
          return _vm.selectImage(image, i);
        }
      }
    }, [_vm._v("編輯")]), _c('b-button', {
      attrs: {
        "disabled": !_vm.canClick,
        "variant": "outline-danger"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteImage(i);
        }
      }
    }, [_vm._v("刪除")])], 1)]);
  }), 0), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "success",
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.gotoScanProduct
    }
  }, [_vm._v("掃描"), _c('br'), _vm._v("其他商品")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("編輯"), _c('br'), _vm._v("團購設定")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }